import { Component, forwardRef, Input } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Observable } from 'rxjs';
import { ExternalSelectorComponent } from '../../external-selector/external-selector.component';
import { IncarichiComponent } from 'src/app/incarichi/incarichi.component';

@Component({
  providers: [
    { provide: MatFormFieldControl, useExisting: forwardRef(() => IncaricoPickerComponent) },
  ],
  selector: 'incarico-picker',
  templateUrl: '../../external-selector/external-selector.component.html',
  styleUrls: ['../../external-selector/external-selector.component.scss']
})
export class IncaricoPickerComponent extends ExternalSelectorComponent {

  @Input()
  get externalEntityObserver(): Observable<any> {
    return this.dialog.open(IncarichiComponent, { data: { selectionMode: true } }).afterClosed();
  };


}
